import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ErrandActionDefaultConfig,
  type ErrandActionDefault,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { cn } from '@/lib/cn';
import Dot from './dot';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const ErrandActionDefaultConfigItem: RelationFieldProps<ErrandActionDefault> =
  {
    nested: getRelationFieldNames(ErrandActionDefaultConfig),
    renderItem: (item, isRelationField) => {
      return {
        title: item.title ?? '',
        descriptionItems: (
          <div
            className={cn(
              'flex items-center',
              isRelationField && 'w-full justify-between'
            )}
          >
            <strong>Kod:</strong> {item.code}
            {!isRelationField && <Dot />}
            <span>{item.isProposal ? 'Åtgärdsförslag' : 'Standardåtgärd'}</span>
            {!isRelationField && <Dot />}
            {item.description ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className='max-w-72 truncate'>
                    {item.description ?? 'Ingen beskrivning'}
                  </div>
                </TooltipTrigger>
                <TooltipContent className='max-w-80'>
                  {item.description}
                </TooltipContent>
              </Tooltip>
            ) : (
              <span>Ingen beskrivning</span>
            )}
          </div>
        ),
      };
    },
  };
